import type { ApiReturnSite } from '@highimpact-frontend/api-types';

import {
  buildWidgetRuntimeApi,
  type WidgetRuntimeApi,
} from '../remote/WidgetRuntimeApi';
import type { DashboardStoreType } from '../state/dashboard/initials';
import type {
  DashboardRuntimeDispatch,
  DashboardScope,
} from '../state/dashboardRuntimeTypes';
import { findGridIdAndTypeByElementId } from './gridLookup';
import type { WidgetInstanceRegistry } from './instanceRegistry/types';
import { readElementFromSlice, readWidgetFromSlice } from './sliceReaders';

export interface BuildWidgetRuntimeApiFromStateParams {
  readonly state: DashboardStoreType;
  readonly dispatch: DashboardRuntimeDispatch;
  readonly checkPermission: WidgetRuntimeApi['checkPermission'];
  readonly scope: DashboardScope;
  readonly site?: ApiReturnSite | null;
  readonly project_id?: number | null;
  readonly instanceRegistry: Pick<
    WidgetInstanceRegistry,
    'registerInstance' | 'unregisterInstance'
  >;
}

/** Builds a {@link WidgetRuntimeApi} from a dashboard runtime store snapshot. */
export function buildWidgetRuntimeApiFromDashboardState(
  params: BuildWidgetRuntimeApiFromStateParams
): WidgetRuntimeApi {
  const { state } = params;

  return buildWidgetRuntimeApi({
    scope: params.scope,
    site: params.site,
    project_id: params.project_id,
    checkPermission: params.checkPermission,
    dispatch: params.dispatch,
    instanceRegistry: params.instanceRegistry,
    getElement: (dashboardElementId) =>
      readElementFromSlice(state, dashboardElementId),
    getWidget: (widgetId) => readWidgetFromSlice(state, widgetId),
    getGridForElement: (dashboardElementId) =>
      findGridIdAndTypeByElementId(dashboardElementId, state),
  });
}
